/**
 * Internal email patterns omitted from Mixpanel when exclusion is enabled in server/client INI or env
 * (mirrors server filter). Lookup: mixpanel exclude internal asynclabs runtheo vertexcover
 */

/** Matches *@asynclabs.ai */
function isAsynclabsEmail(emailLower: string): boolean {
  return emailLower.endsWith("@asynclabs.ai");
}

/** Matches *@runtheo.<tld> and *.*.runtheo.<tld> (e.g. user@runtheo.app, user@dev.runtheo.app). */
function isRuntheoGlobEmail(emailLower: string): boolean {
  const at = emailLower.lastIndexOf("@");
  if (at < 0) return false;
  const host = emailLower.slice(at + 1);
  const parts = host.split(".");
  const idx = parts.indexOf("runtheo");
  if (idx < 0) return false;
  /* runtheo must sit immediately before the public suffix: user@runtheo.app or user@x.runtheo.app */
  return idx === parts.length - 2;
}

/**
 * When internal-email exclusion is enabled (e.g. client-prod.ini / server-prod.ini), return true to skip Mixpanel.
 */
export function shouldExcludeInternalEmailFromMixpanel(email: string | undefined | null): boolean {
  if (email == null || typeof email !== "string") return false;
  const e = email.trim().toLowerCase();
  if (!e) return false;
  if (e === "ranjan@vertexcover.io") return true;
  if (isAsynclabsEmail(e)) return true;
  if (isRuntheoGlobEmail(e)) return true;
  return false;
}
